import aiConsultImage from 'assets/AIConsult.jpg'
// // import { Protect } from '@clerk/clerk-react'
import { useEffect, useRef, useState } from 'react'
import { graphql } from 'relay-runtime'
import { useLazyLoadQuery, useMutation } from 'react-relay'
import { useUserStore } from '@/defines/store/userStore'
import type { aiConsultDetailQuery as AiConsultQueryType } from './__generated__/aiConsultDetailQuery.graphql'
import type { aiConsultDetailUpdateChatMutation as AiConsultUpdateType } from './__generated__/aiConsultDetailUpdateChatMutation.graphql'
import userImage from 'assets/user.png'
import { PaperAirplaneIcon } from '@heroicons/react/24/outline'
import { ChatViewModel, RequestStatus } from '@/defines/requestDefines'

const AiConsultDetailUpdateChatMutation = graphql`
mutation aiConsultDetailUpdateChatMutation($linkparameter: String!, $chatHistory: String!){
    update_request_ai_consult_detail(where: {linkparameter: {_eq: $linkparameter}}, _set: {chatHistory: $chatHistory}) {
        affected_rows
    }
}
`

const AiConsultDetailQuery = graphql`
query aiConsultDetailQuery($linkparameter: String!, $recipientid: String!){
  insurance_request_log_connection(where: {request_ai_consult_details: {linkparameter: {_eq: $linkparameter}}, recipientid: {_eq: $recipientid}}) {
    edges {
      node {
        request_ai_consult_details {
          id
          linkparameter
          startchatdate
          created_at
          chatHistory
        }
        recipient {
          id
          email
          imageurl
          last_seen
          name
        }
        requeststatus
        requesttype
        recipientid
        insuranceid
        id
        created_at
        caredetailid
        aiconsultdetailid

        insurance {
          id
          name
          user {
            imageurl
          }
        }
      }
    }
  }
}
`

interface RequestChatViewModel {
    aiconsultdetailid: number | null | undefined;
    caredetailid: number | null | undefined;
    created_at: Date | null | undefined;
    id: string;
    insuranceid: string;
    recipientid: string | null | undefined;
    request_ai_consult_details: {
        created_at: any;
        id: string;
        linkparameter: string;
        startchatdate: any;
        chatHistory: string;
    } | null | undefined;
    recipient: {
        email: string | null | undefined;
        id: string;
        imageurl: string | null | undefined;
        last_seen: any;
        name: string;
    } | null | undefined;
    requeststatus: number;
    requesttype: number;
    insurance: {
        id: string;
        name: string;
        user: {
            imageurl: string | null | undefined;
        } | null | undefined;
    } | null | undefined;
}

export default function AiConsult() {
    const [data, setData] = useState({} as RequestChatViewModel);
    const [useable, setUsable] = useState(false);
    const [messages, setMessages] = useState([] as ChatViewModel[]);
    const [userTypingMessage, setUserTypingMessage] = useState('');
    const userId = useUserStore.getState().userData.id;
    const [commitUpdate] = useMutation<AiConsultUpdateType>(AiConsultDetailUpdateChatMutation);
    const [expiredDate, setExpiredDate] = useState(new Date());

    const search = window.location.search
    const params = new URLSearchParams(search)
    const linkparameter = params.get('linkparameter')

    if (!linkparameter) return;

    const aiConsultData = useLazyLoadQuery<AiConsultQueryType>(
        AiConsultDetailQuery,
        {
            recipientid: userId,
            linkparameter: linkparameter ?? ''
        },
    );

    useEffect(() => {
        console.log(aiConsultData);
        if (aiConsultData?.insurance_request_log_connection?.edges.length == 0) {
            return;
        }
        aiConsultData?.insurance_request_log_connection?.edges.forEach(item => {
            let forAdd = {} as RequestChatViewModel;
            if (item.node.request_ai_consult_details) {
                forAdd.request_ai_consult_details = {
                    created_at: item.node.request_ai_consult_details.created_at,
                    id: item.node.request_ai_consult_details.id,
                    linkparameter: item.node.request_ai_consult_details.linkparameter,
                    startchatdate: item.node.request_ai_consult_details.startchatdate,
                    chatHistory: item.node.request_ai_consult_details.chatHistory,
                };
            }
            if (item.node.recipient) {
                forAdd.recipient = {
                    email: item.node.recipient.email,
                    id: item.node.recipient.id,
                    imageurl: item.node.recipient.imageurl,
                    last_seen: item.node.recipient.last_seen,
                    name: item.node.recipient.name,
                };
            }
            if (item.node.insurance) {
                forAdd.insurance = {
                    id: item.node.insurance.id,
                    user: {
                        imageurl: item.node.insurance.user?.imageurl
                    },
                    name: item.node.insurance.name,
                };
            }
            forAdd.id = item.node.id;
            forAdd.aiconsultdetailid = item.node.aiconsultdetailid;
            forAdd.caredetailid = item.node.caredetailid;
            forAdd.created_at = item.node.created_at;
            forAdd.insuranceid = item.node.insuranceid;
            forAdd.recipientid = item.node.recipientid;
            forAdd.requeststatus = item.node.requeststatus;
            forAdd.requesttype = item.node.requesttype;
            setData(forAdd);
        });

    }, [aiConsultData])

    useEffect(() => {
        if (data.request_ai_consult_details?.chatHistory) {
            let chats: ChatViewModel[] = JSON.parse(data.request_ai_consult_details?.chatHistory);
            if (chats && chats.length > 0) {
                setMessages(chats);
            }
        }
        if (data.request_ai_consult_details?.startchatdate) {
            const temp = new Date(data.request_ai_consult_details.startchatdate);
            setExpiredDate(new Date(temp.setDate(temp.getDate() + 3)));
        }

        if (data.request_ai_consult_details?.startchatdate) {
            const temp = new Date(data.request_ai_consult_details.startchatdate);
            const tempExpired = new Date(temp.setDate(temp.getDate() + 3));
            if(tempExpired < new Date() || data.requeststatus !== RequestStatus.chatUsing){
                setUsable(false);
            }
            else{
                setUsable(true);
            }
        }
    }, [data])

    const updateChat = (addMessage: string, isSendByUser: boolean) => {
        console.log('updateChat', addMessage);
        // 使用新的數組來更新狀態
        const newMessage = {
            date: new Date(),
            isSendByUser: isSendByUser,
            message: addMessage
        } as ChatViewModel;
        setMessages(prevMessages => [...prevMessages, newMessage]);
    }

    const messagesEndRef = useRef<HTMLDivElement>(null);
    const scrollToBottom = () => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    };

    useEffect(() => {
        scrollToBottom();

        if (messages.length > 0) {
            commitUpdate({
                variables: {
                    linkparameter: linkparameter,
                    chatHistory: JSON.stringify(messages),
                },
                onCompleted: () => {
                    if (messages[messages.length - 1].isSendByUser) {
                        setUserTypingMessage('');
                    }
                    console.log('onCompleted');
                },
                onError: (error) => {
                    console.error('Error updating user', error);
                }
            });
        }

    }, [messages]);

    return (
        <div className="bg-white">
            <div className="mx-auto" style={{ "maxWidth": "1400px" }}>
                <div className="md:grid md:grid-cols-12 max-sm:flex max-sm:flex-col mt-12">
                    <div className="md:col-span-3 p-2">
                        <img
                            src={aiConsultImage}
                            style={{ maxWidth: '100%', maxHeight: '60vh' }}
                            className="object-cover object-center rounded-xl"
                        />

                        <h3 className="mt-3 text-xl font-bold tracking-tight text-gray-900">基本資訊</h3>
                        <div className="mt-3 sm:col-span-3 grid grid-cols-1 gap-x-6 gap-y-3">
                            <div>
                                <label htmlFor="first-name" className="block text-sm font-medium leading-6 text-gray-900">
                                    開始時間
                                </label>
                                <div className="mt-2">
                                    <input
                                        id="city"
                                        name="city"
                                        type="text"
                                        value={new Date(data.request_ai_consult_details?.startchatdate).toLocaleString()}
                                        disabled={true}
                                        // onChange={(e) => setMedicalCenter({ ...medicalCenter, city: e.target.value })}
                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm 
                                            ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset 
                                            focus:ring-red-400 sm:text-sm sm:leading-6"
                                    />
                                </div>
                            </div>
                            <div>
                                <label htmlFor="first-name" className="block text-sm font-medium leading-6 text-gray-900">
                                    逾期時間
                                </label>
                                <div className="mt-2">
                                    <input
                                        id="city"
                                        name="city"
                                        type="text"
                                        value={expiredDate.toLocaleString()}
                                        disabled={true}
                                        // onChange={(e) => setMedicalCenter({ ...medicalCenter, city: e.target.value })}
                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm 
                                            ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset 
                                            focus:ring-red-400 sm:text-sm sm:leading-6"
                                    />
                                </div>
                            </div>

                            <div>
                                <label htmlFor="first-name" className="block text-sm font-medium leading-6 text-gray-900">
                                    協助之業務員
                                </label>
                                <div className="flex justify-between mt-2">
                                    <img className='mx-4 size-12 flex-none rounded-full bg-gray-50' src={data.insurance?.user?.imageurl ?? userImage} />
                                    <input
                                        id="city"
                                        name="city"
                                        type="text"
                                        value={data.insurance?.name}
                                        disabled={true}
                                        // onChange={(e) => setMedicalCenter({ ...medicalCenter, city: e.target.value })}
                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm 
                                            ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset 
                                            focus:ring-red-400 sm:text-sm sm:leading-6"
                                    />
                                </div>
                            </div>

                        </div>

                    </div>
                    <div className="md:col-span-9 max-sm:order-last px-4">


                        {/* 諮詢紀錄 */}
                        {
                            data.request_ai_consult_details?.chatHistory === undefined ?
                                <></> :
                                <div className="h-[70vh]">
                                    <div className="chat-area flex-1 flex flex-col h-4/5 p-4 overflow-auto bg-gray-100 rounded-lg">
                                        <div className="messages flex-1 ">
                                            {messages.map((chat) => (
                                                chat.isSendByUser ?
                                                    <div className="message me mb-4 flex text-right">
                                                        <div className="flex-1 px-2">
                                                            <div className="inline-block bg-blue-600 rounded-lg p-2 px-6 text-white">
                                                                <span>{chat.message}</span>
                                                            </div>
                                                            <div className="pr-4"><small className="text-gray-500">{new Date(chat.date).toLocaleString()}</small></div>
                                                        </div>
                                                    </div>
                                                    :
                                                    <div className="message mb-4 flex">
                                                        <div className="flex-2">
                                                            <div className="w-12 h-12 relative">
                                                                <img className="w-12 h-12 rounded-full mx-auto" src={aiConsultImage} alt="chat-user" />
                                                            </div>
                                                        </div>
                                                        <div className="flex-1 px-2">
                                                            <div className="inline-block bg-gray-300 rounded-lg p-2 px-6 text-gray-700">
                                                                <span>{chat.message}</span>
                                                            </div>
                                                            <div className="pl-4"><small className="text-gray-500">{new Date(chat.date).toLocaleString()}</small></div>
                                                        </div>
                                                    </div>
                                            ))}
                                            <div ref={messagesEndRef} />
                                        </div>
                                    </div>
                                    {
                                        useable ? 
                                        <div className="flex-2 pt-4 pb-10">
                                            <div className="write bg-white shadow flex rounded-lg">
                                                <div className="flex-1 py-2">
                                                    <input name="message" className="w-full rounded-full block py-4 px-4 bg-transparent"
                                                        placeholder="Type a message..." autoFocus={true}
                                                        value={userTypingMessage}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                updateChat(userTypingMessage, true)
                                                            }
                                                        }}
                                                        onChange={(e) => setUserTypingMessage(e.target.value)} />
                                                </div>
                                                <div className="flex-2 p-2 flex content-center items-center">
                                                    <button
                                                        type="button"
                                                        className="inline-flex items-center justify-center mx-1 w-10 h-10 rounded-md bg-red-400 text-sm font-semibold text-white 
                                                        shadow-sm hover:bg-red-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                                                        onClick={() => {
                                                            updateChat(userTypingMessage, true)
                                                        }}>
                                                        <PaperAirplaneIcon
                                                            aria-hidden="true"
                                                            className="w-5 h-5 md:block"
                                                        />
    
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        : <></>
                                    }

                                </div>
                        }
                    </div>
                </div>
            </div >

        </div >

    )
}
